Human readable descriptions of the remuneration package.

The `seekAnz` scheme will be limited to a single element.

An empty array signifies that no salary descriptions exist for the remuneration package.
